import request from '@/utils/request'
const apiPath = '/im/imConversation'
const imConversationApi = {
  getUserSign(data) {
    return request.post(apiPath + '/tee/proLoginForKeFu', data)
  },
  setReadMessage(data) {
    return request.put(apiPath + '/tee/setReadMessage', data)
  },
  setIsTop(data) {
    return request.put(apiPath + '/tee/setIsTop', data)
  },
  setEnd(data) {
    return request.put(apiPath + '/tee/end', data)
  },
  transferForKeFu(data) {
    return request.post(apiPath + '/tee/transferForKeFu', data)
  },
  fetchList(query) {
    return request.get(apiPath + '/tee/listPage', { params: query })
  },
  fetchMeList(query) {
    return request.get(apiPath + '/tee/listPageForMiniOWN', { params: query })
  },
}
export default imConversationApi
